import strings from 'owa-strings/owa-options-strings';
export default function getImportanceOptions() {
    return [
        { value: 'High', text: strings.options_inboxRules_high },
        { value: 'Normal', text: strings.options_inboxRules_normal },
        { value: 'Low', text: strings.options_inboxRules_low },
    ];
}
//# sourceMappingURL=getImportanceOptions.js.map